<mat-card *ngIf="!stayAndSaveDetail?.promoApplied">
  <mat-card-content>
    <h6>
      Stay {{ getMonth(stayAndSaveDetail?.numMonthsForPromo) }} Month{{
        plural
      }}, Get a Free Month!
    </h6>
    <div class="progress-container">
      <img
        src="https://cdn.dontdrivedirty.com/myqq/img/staynsave-in-progress-quackal.svg"
        class="progress-image"
      />
      <div class="progress-bar-wrapper">
        <mat-progress-bar
          class="gradient-progress-bar"
          mode="determinate"
          [value]="progressValue"
        ></mat-progress-bar>
        <div
          class="progress-bar-overlay"
          [ngStyle]="{ width: progressValue + '%' }"
        ></div>
      </div>
    </div>
    <span>On your way to a free month.</span
    ><span class="days">
      Just {{ stayAndSaveDetail?.daysRemainingForPromo }} days to go!</span
    >
  </mat-card-content>
</mat-card>

<mat-card *ngIf="stayAndSaveDetail?.promoApplied" class="rainbow-border">
  <mat-card-content>
    <h6>Free month active! 🥳 🤩 🥳</h6>
    <div class="progress-container">
      <img
        src="https://cdn.dontdrivedirty.com/myqq/img/green-foam-hand-quackal.svg"
        class="progress-image"
      />
      <img
        src="https://cdn.dontdrivedirty.com/myqq/img/animation_Color_fireworks.gif"
        id="animation-image"
        class="animation-image"
      />
      <div class="gradient-wrapper">
        <mat-progress-bar
          class="complete-progress-bar"
          id="complete"
          mode="determinate"
          [value]="100"
        ></mat-progress-bar>
      </div>
    </div>
    <span> Congratulations, enjoy your free month.</span>
  </mat-card-content>
</mat-card>
